<template>
    <div style="box-sizing: border-box;padding-top: 20px;">
        <div class="forms">
            <div class="formTitle flx alc jsb">
                <div class="ftname">
                    基础信息
                </div>
                <div class="acRight flx alc" :style="level == 2?'visibility:hidden' : ''">
                    <div class="acrtips">
                        为了不影响您活动报名、提现和管理，请及时认证
                    </div>
                    <el-button type="primary" @click="toConfirm">马上认证</el-button>
                </div>
            </div>
            <div v-if="level == 2">
                <div class="formitem alc flx">
                    <div class="finame" style="box-sizing: border-box;padding-top: 10px;">
                        <span style="color: #FF4949;">*</span>
                        <span>企业头像:</span>
                    </div>
                    <div class="ips">
                        <el-upload :show-file-list="false" action="https://hrxsl.com/api/Common/oss_upload"
                            :on-success="uploadsAvatar" :headers="uploadHeaders">
                            <div class="cavatar">
                                <img class="companyAvatar" v-if="forms.shop_avatar == ''"
                                    :src="$Localimg('defaultAvatar.png')" alt="" />
                                <img class="companyAvatar" :src="$img(forms.shop_avatar)" alt="" v-else />
                                <img class="edav" :src="$Localimg('editAvatar.png')" alt="" />
                            </div>
                        </el-upload>
                    </div>
                </div>
                
                <div class="formitem flx alc">
                    <div class="finame">
                        <span style="color: #FF4949;">*</span>
                        <span>企业名称:</span>
                    </div>
                    <div>
                        <div class="ips">
                            <div class="inps">
                                <el-input :maxlength="30" placeholder="请输入企业名称" v-model="forms.shop_name"></el-input>
                            </div>
                        </div>
                    </div>
                </div>
                
                <div class="formitem flx alc">
                    <div class="finame">
                        <span style="color: #FF4949;">*</span>
                        <span>企业地址:</span>
                    </div>
                    <div>
                        <div class="ips">
                            <div class="inps">
                                <el-input :maxlength="130" placeholder="请输入公司地址" v-model="forms.shop_address"></el-input>
                            </div>
                        </div>
                    </div>
                </div>
                
                <div class="formitem flx">
                    <div class="finame">
                        <span style="color: #FF4949;">*</span>
                        <span>企业标签:</span>
                    </div>
                    <div>
                        <div class="ips">
                            <div class="inps">
                                <el-input :maxlength="6" v-model="forms.shop_label" placeholder="请输入企业标签"></el-input>
                            </div>
                        </div>
                        <div class="tip">
                            最多可以输入6字
                        </div>
                    </div>
                </div>
                
                <div class="formitem flx">
                    <div class="finame">
                        <span style="color: #FF4949;">*</span>
                        <span>企业规模:</span>
                    </div>
                    <div>
                        <div class="ips">
                            <div class="inps">
                                <el-input :maxlength="6" v-model="forms.shop_people" placeholder="请输入企业规模"></el-input>
                            </div>
                        </div>
                    </div>
                </div>
                
                <div class="formitem flx">
                    <div class="finame">
                        <!-- <span style="color: #FF4949;">*</span> -->
                        <span>企业介绍:</span>
                    </div>
                    <div>
                        <div class="ips">
                            <div style="width: 500px;">
                                <el-input :rows="6" maxlength="2000" :show-word-limit="true" type="textarea" resize="none"
                                    count placeholder="请输入企业描述" v-model="forms.shop_intro">
                                </el-input>
                            </div>
                        </div>
                    </div>
                </div>
                
                <div class="formitem flx">
                    <div class="finame">
                        <!-- <span style="color: #FF4949;">*</span> -->
                        <span>企业相册</span>
                    </div>
                    <div>
                        <div class="ips flx pois alc" >
                            <el-upload class="upload-demo" :show-file-list="false"
                                action="https://hrxsl.com/api/Common/oss_upload" :on-success="handleAvatarSuccess"
                                :before-upload="beforeAvatarUpload" :headers="uploadHeaders" v-if="imgs.length < 6">
                                <div class="upimage">
                                    <img :src="$Localimg('uploadImage.png')" alt="" />
                                </div>
                            </el-upload>
                            <div class="imgItme" v-for="item,index in imgs" :style="index == 0?'margin-top:0' : ''">
                                <img :src="$img(item)" alt="" style="object-fit: contain;" />
                                <div class="dels" @click="del(index)">
                                    <i style="color: #fff;font-size: 12px;" class="el-icon-delete"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                
                
                <div class="formitem flx">
                    <div class="finame">
                        <span style="color: #FF4949;">*</span>
                        <span>企业简介</span>
                    </div>
                    <div>
                        <div class="ips flx alc" style="width: 880px;flex-wrap: wrap;">
                            <el-upload class="upload-demo" :show-file-list="false"
                                action="https://hrxsl.com/api/Common/oss_upload" :on-success="handleAvatarSuccess1"
                                :before-upload="beforeAvatarUpload1" :headers="uploadHeaders" v-if="imgs.length < 6">
                                <div class="upimage">
                                    <img :src="$Localimg('uploadImage.png')" alt="" />
                                </div>
                            </el-upload>
                            <div class="imgItme" v-for="item,index in imgss" :style="index == 0?'margin-top:0' : ''">
                                <img :src="$img(item)" alt="" style="object-fit: contain;" />
                                <div class="dels" @click="del1(index)">
                                    <i style="color: #fff;font-size: 12px;" class="el-icon-delete"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                
                <!-- <div class="formTitle flx alc">
                    <div class="ftname">
                        工商信息
                    </div>
                </div>
                
                <div class="formitem flx alc">
                    <div class="finame">
                        <span style="color: #FF4949;">*</span>
                        <span>企业全称:</span>
                    </div>
                    <div>
                        <div class="ips">
                            <div class="inps">
                                <el-input :maxlength="30" v-model="val1" disabled placeholder="请输入企业全称"></el-input>
                            </div>
                        </div>
                    </div>
                </div>
                
                <div class="formitem flx alc">
                    <div class="finame">
                        <span style="color: #FF4949;">*</span>
                        <span>法定代表人:</span>
                    </div>
                    <div>
                        <div class="ips">
                            <div class="inps">
                                <el-input :maxlength="30" v-model="val2" disabled placeholder="请输入法定代表人"></el-input>
                            </div>
                        </div>
                    </div>
                </div>
                
                <div class="formitem flx alc">
                    <div class="finame">
                        <span style="color: #FF4949;">*</span>
                        <span>注册资本:</span>
                    </div>
                    <div>
                        <div class="ips">
                            <div class="inps">
                                <el-input :maxlength="30" disabled placeholder="请输入注册资本" v-model="val3"></el-input>
                            </div>
                        </div>
                    </div>
                </div>
                
                <div class="formitem flx alc">
                    <div class="finame">
                        <span style="color: #FF4949;">*</span>
                        <span>成立日期:</span>
                    </div>
                    <div>
                        <div class="ips">
                            <div class="inps">
                                <el-input :maxlength="30" disabled placeholder="请输入成立日期" v-model="val4"></el-input>
                            </div>
                        </div>
                    </div>
                </div> -->
                <div class="bot">
                    <div class="flx alc jsc">
                        <el-button type="primary" @click="subThis(3)">提交信息</el-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {
        getCompany,
        subCompany
    } from "@/api/index.js"
    export default {
        data() {
            return {
                level:"",
                forms: {
                    shop_avatar: '',
                    shop_name: "",
                    shop_address: '',
                    shop_label: "",
                    shop_intro: "",
                    shop_people:""
                },
                imgs: [],
                imgss: [],
                uploadHeaders: {
                    token: localStorage.getItem('token'),
                    source: "pc"
                },
                val1: "",
                val2: "",
                val3: "",
                val4: ""
            }
        },
        created() {
            this.getDetail()
        },
        methods: {
            del(e) {
                this.imgs.splice(e, 1)
            },
            del1(e) {
                this.imgss.splice(e, 1)
            },
            uploadsAvatar(e) {
                let that = this
                if (e.code == 1) {
                    that.forms.shop_avatar = e.data.url
                }
            },
            toConfirm() {
                this.$router.push('/verify')
            },
            getDetail() {
                let that = this
                getCompany().then((res) => {
                    console.log(11, res)
                    if (res.code == 1) {
                        that.val1 = res.data.zz_name
                        that.val2 = res.data.zz_qiye
                        that.val3 = res.data.zz_ziben
                        that.val4 = res.data.zz_time
                        that.level = res.data.level
                        that.forms.shop_avatar = res.data.shop_avatar
                        that.forms.shop_name = res.data.shop_name
                        that.forms.shop_address = res.data.shop_address
                        that.forms.shop_label = res.data.shop_label
                        that.forms.shop_people = res.data.shop_people
                        that.forms.shop_intro = res.data.shop_intro
                        that.imgs = res.data.shop_images.length>0? res.data.shop_images.split(",").filter(item => item.trim()) : []
                        that.imgss = res.data.shop_content?res.data.shop_content.split(",").filter(item => item.trim()):[]
                        that.$nextTick(() => {
                            window.scrollTo(0, 0)
                        })
                    }
                })
            },
            subThis(e) {
                let that = this
                let data = that.forms
                data.shop_images = that.imgs.join()
                data.shop_content = that.imgss.join()
                subCompany(data).then((res) => {
                    if (res.code == 1) {
                        that.$message.success(res.msg)
                    } else {
                        that.$message.error(res.msg)
                    }
                })
            },
            delThis(e) {
                this.fees.splice(e, 1)
            },
            // 图片上传成功回调
            uploadSuccess(res) {
                let that = this
                if (res.code == 1) {
                    that.uploadImgUrl.push(that.$img(res.data.url))
                } else {
                    // this.$message.error(res.msg || '图片上传失败')
                }
            },
            handleAvatarSuccess(e) {
                let that = this
                if (e.code == 1) {
                    that.imgs.push(e.data.url)
                } else {
                    this.$message.error(e.data.msg)
                }
            },
            beforeAvatarUpload(file) {
                // 1. 允许的图片格式
                const allowType = ['image/png', 'image/jpg', 'image/jpeg']
                // 2. 最大8MB
                const maxSize = 3 * 1024 * 1024

                // 校验格式
                if (!allowType.includes(file.type)) {
                    this.$message.error('仅支持 png、jpg、jpeg 格式图片！')
                    return false
                }

                // 校验大小
                if (file.size > maxSize) {
                    this.$message.error('图片不能大于8MB！')
                    return false
                }

                // 校验通过，允许上传
                return true
            },
            beforeAvatarUpload1(file) {
                // 1. 允许的图片格式
                const allowType = ['image/png', 'image/jpg', 'image/jpeg']
                // 2. 最大8MB
                const maxSize = 7 * 1024 * 1024

                // 校验格式
                if (!allowType.includes(file.type)) {
                    this.$message.error('仅支持 png、jpg、jpeg 格式图片！')
                    return false
                }
                // 校验大小
                if (file.size > maxSize) {
                    this.$message.error('图片不能大于8MB！')
                    return false
                }
                // 校验通过，允许上传
                return true
            },
            handleAvatarSuccess1(e) {
                let that = this
                if (e.code == 1) {
                    that.imgss.push(e.data.url)
                } else {
                    this.$message.error(e.data.msg)
                }
            },
        }
    }
</script>

<style scoped>
    .pois{
        width: 880px;
        flex-wrap: wrap;
    }
    .tip {
        font-size: 14px;
        color: #999999;
        margin-top: 12px;
        text-align: left;
    }

    .cavatar {
        width: 78px;
        height: 78px;
        position: relative;
    }

    .cavatar .companyAvatar {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    .edav {
        width: 18px;
        height: 18px;
        position: absolute;
        z-index: 4;
        bottom: 2px;
        right: 2px;
    }

    .bot .el-button {
        width: 209px !important;
        height: 46px !important;
    }

    .rules {
        margin-top: 24px;
    }

    .inner {
        width: 100%;
        height: 100%;
        background: #007AFF;
    }

    .rule {
        font-weight: 500;
        font-size: 12px;
        color: #333333;
    }


    /* 控制编辑器高度 */
    /deep/ .quill-editor {
        height: 400px;
    }

    /* 工具栏底部边框 */
    /deep/ .ql-toolbar.ql-snow {
        border: 1px solid #e4e7ed;
        border-bottom: none;
    }

    /* 编辑区域边框 */
    /deep/ .ql-container.ql-snow {
        border: 1px solid #e4e7ed;
        min-height: 320px;
    }

    .imgItme {
        width: 300px;
        height: 183px;
        margin-right: 20px;
        position: relative;
        margin-top: 20px;
        border: 1px dashed #DCDFE6;
    }

    .dels {
        position: absolute;
        width: 20px;
        height: 20px;
        background: rgba(0, 0, 0, 0.39);
        right: 8px;
        top: 8px;
        z-index: 2;
        cursor: pointer;
        text-align: center;
        line-height: 20px;
        border-radius: 50%;
    }

    .imgItme img {
        width: 100%;
        height: 100%;
        border-radius: 6px;
    }

    .taAdd {
        padding: 20px 0;
    }


    .rules {
        margin-top: 24px;
    }

    .inner {
        width: 100%;
        height: 100%;
        background: #007AFF;
    }

    .rule {
        font-weight: 500;
        font-size: 12px;
        color: #333333;
    }

    .squ {
        width: 14px;
        height: 14px;
        border-radius: 1px;
        border: 1px solid #D9D9D9;
        margin-right: 8px;
        box-sizing: border-box;
        padding: 2px;
    }

    .formitem {
        margin-bottom: 30px;
    }

    .tis .tiitem {
        font-size: 12px;
        color: #838383;
        text-align: left;
        line-height: 24px;
        margin-left: 20px;
    }

    .finame {
        margin-right: 20px;
        font-size: 14px;
        color: #48576A;
        text-align: right;
        width: 100px;
        flex-shrink: 0;
    }

    .ips .inps {
        width: 300px;
        height: 46px;
    }

    .upimage {
        width: 300px;
        height: 183px;
    }

    .upimage img {
        width: 100%;
        height: 100%;
        object-fit: contain;
    }

    .formTitle {
        margin-bottom: 31px;
    }

    .ftname {
        font-weight: 600;
        font-size: 18px;
    }

    .upload-demo {
        width: 300px !important;
        height: 183px !important;
        margin-right: 20px;
    }

    .forms {
        background-color: #fff !important;
        margin: 0 auto;
        box-sizing: border-box;
        padding: 25px 30px;
    }
</style>